


function zoom_scale(level, subdivision = 10, base = 10) {
    const pow = Math.floor(level / (subdivision - 1));
    const curLevel = Math.pow(base, pow - 1);
    const intra_size = 1 + level % (subdivision - 1);


    return curLevel * intra_size;
}

const MIN_GRID_SIZE = zoom_scale(0);
const GRID_RESOLUTION = 20;

function computeViewportHalfSize(level, gridResolution = 40, subdivision, base) {
    return zoom_scale(level, subdivision, base) * gridResolution / 2;
}

export {
    MIN_GRID_SIZE,
    GRID_RESOLUTION,
    computeViewportHalfSize,
    zoom_scale,
}